import { TimeRange } from "sbtech-sports-data-api-client";
import { SportDataGatewayQueryInfo } from "sb-bff-integration";
export var preLiveSportApiQuery = function (handler, languageCode, from) {
    var query = "$filter=fixturesCount gt 0";
    var queryInfo = new SportDataGatewayQueryInfo(query, handler);
    queryInfo.timeRange = TimeRange.SixHours;
    queryInfo.locale = languageCode;
    queryInfo.from = from.toISOString();
    return queryInfo;
};
export var preLiveSportApiQueryFactory = function (languageCode, dateConstructor) {
    return function (handler) {
        return preLiveSportApiQuery(handler, languageCode, new dateConstructor());
    };
};
export var liveSportApiQuery = function (handler, languageCode) {
    var query = "$filter=liveFixturesTotalCount gt 0 or liveOutrightsTotalCount gt 0";
    var queryInfo = new SportDataGatewayQueryInfo(query, handler);
    queryInfo.locale = languageCode;
    return queryInfo;
};
export var liveSportApiQueryFactory = function (languageCode) {
    return function (handler) { return liveSportApiQuery(handler, languageCode); };
};
export var todaySportApiQuery = function (handler, languageCode, from) {
    var queryInfo = new SportDataGatewayQueryInfo("", handler);
    queryInfo.timeRange = TimeRange.OneDay;
    queryInfo.locale = languageCode;
    queryInfo.from = from.toISOString();
    return queryInfo;
};
export var todaySportApiQueryFactory = function (languageCode) {
    return function (fromProvider) {
        return function (handler) {
            return todaySportApiQuery(handler, languageCode, fromProvider());
        };
    };
};
//# sourceMappingURL=SportApiQueries.js.map